import React, { useEffect, useState } from "react";
import styles from "./DashProListings.module.css";
import { useAuth } from "../../../contexts/AuthContext";
import axios from "axios";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { listingStates } from "../../../util/flStates";
import DashRentListings from "../dashboardUtil/DashRentListings/DashRentListings";
import DashSellListings from "../dashboardUtil/DashSellListings/DashSellListings";
import { toast } from "react-toastify";

function DashProListings({ showErrorMessage, setPageLoading }) {
  const navigate = useNavigate();
  const { accessToken } = useAuth();
  const [listings, setListings] = useState([]);
  const [sellListings, setSellListings] = useState([]);
  const [rentListings, setRentListings] = useState([]);
  const [listingType, setListingType] = useState(listingStates.rent);

  const handleAddListing = () => {
    // alert("add lsiting");
    navigate(`/realtor/add-property`);
  };

  // Function to sort listings by created_at
  const sortListings = (listings) => {
    return listings.sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
  };

  const fetchListings = async () => {
    setPageLoading(true);
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_BACKEND_URL}/dash/pro-listings`,
        {
          headers: {
            Authorization: accessToken,
          },
        }
      );

      // console.log("response: ", response);

      if (response.status === 200) {
        if (response.data.success) {
          setListings(response.data.listings || []);

          if (response.data.listings && response.data.listings.length) {
            // // console.log()
            // console.log("listings count: ", response.data.listings.length);
            var liveRentListings = response.data.listings.filter(
              (listing) => listing.listing_type == listingStates.rent
            );
            var liveSellListings = response.data.listings.filter(
              (listing) => listing.listing_type == listingStates.sell
            );
            // console.log("liveRentListings: ", liveRentListings.length);
            // console.log("liveSellListings: ", liveSellListings.length);
            setRentListings(sortListings(liveRentListings) || []);
            setSellListings(sortListings(liveSellListings) || []);
          }
        } else {
          const errorMsg = response.data.message || "Error fetching listings.";
          showErrorMessage(errorMsg);
        }
      } else {
        const errorMsg = response.data.message || "Error fetching listings.";
        showErrorMessage(errorMsg);
      }
    } catch (error) {
      console.error("Error: ", error);
      showErrorMessage("Error fetching listings. Please try again!");
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    fetchListings();
  }, []);

  const handleRestore = async (listingId) => {
    try {
      const response =  await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/listings/restore/${listingId}`,
        {},
        {
          headers: { Authorization: accessToken },
        }
      );
      if (response.status === 200 && response.data.success) {
        const emailResponse = await axios.post(
            `${import.meta.env.VITE_BACKEND_URL}/listing/relist/send`,
            {
              listingId : listingId
            },
            {
              headers: { Authorization: accessToken },
            }
          );
             
      } else {
        const errorMsg = response.data.message || "Error sending email";
        toast.error(errorMsg);
      }

      // Refresh listings after restore
      fetchListings();
    } catch (error) {
      // console.log(error);
      toast.error("Error restoring listing:", error);
    }
  };

  return (
    <div className={styles.sectionContainer}>
      <h1 className={styles.mainTitle}>Manage Your Pro Listings</h1>
      <div className={styles.addListingContainer}>
        <h1 style={{ color: "#1e40af", marginBottom: "3rem" }}>Add Your Pro Listing</h1>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleAddListing}
        >
          Add Listing
        </Button>
      </div>
      <h1 style={{ marginBottom: "2rem" }}>View Your Pro Listing</h1>
      <div className={styles.showlistingsContainer}>
        {listings && listings.length ? (
          <div>
            <div className={styles.rentSellSelectionContainer}>
              <div className={styles.rentSellSelectionBox}>
                <Button
                  className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionLeft}`}
                  variant={
                    listingType === listingStates.rent
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => setListingType(listingStates.rent)}
                >
                  Rent
                </Button>
                <Button
                  className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionRight}`}
                  variant={
                    listingType === listingStates.sell
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => setListingType(listingStates.sell)}
                >
                  Sell
                </Button>
              </div>
            </div>
            <div>
              {listingType === listingStates.rent ? (
                <div>
                  <DashRentListings
                    passedListings={rentListings}
                    accessToken={accessToken}
                    handleRestore={handleRestore}
                    role="pro"
                  />
                </div>
              ) : listingType === listingStates.sell ? (
                <div>
                  <DashSellListings
                    passedListings={sellListings}
                    accessToken={accessToken}
                    handleRestore={handleRestore}
                    role="pro"
                  />
                </div>
              ) : (
                <div>No listing type found</div>
              )}
            </div>
          </div>
        ) : (
          <div>
            You do not have any listings yet. Start listing your properties now
          </div>
        )}
      </div>
    </div>
  );
}

export default DashProListings;
